import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import ProductDetail from "@/pages/ProductDetail";
import PaymentStatus from "@/pages/PaymentStatus";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import Admin from "@/pages/Admin";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/produkt/:id" element={<ProductDetail />} />
        <Route path="/payment/success" element={<PaymentStatus success />} />
        <Route path="/payment/cancel" element={<PaymentStatus />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
